import React, { useState } from "react";
import styled from "styled-components";
import { FiInfo } from "react-icons/fi";

const Container = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

const TriggerButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 0;
  color: #ff9f1f;

  &:hover {
    color: #e6900a;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 159, 31, 0.5);
    outline-offset: 2px;
    border-radius: 50%;
  }
`;

const Box = styled.div`
  position: absolute;
  left: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%);
  width: 300px;
  max-width: 80vw;
  background: #ffffff;
  border: 1.5px solid #002e3b;
  border-radius: 16px;
  padding: 12px 16px;
  font-family: "Public Sans";
  font-size: 13px;
  line-height: 1.45;
  color: #4b5563;
  text-align: left;
  box-shadow: 0 4px 14px rgba(0, 46, 59, 0.12);
  z-index: 1000;
  cursor: default;

  /* seta (borda) apontando para a esquerda, em direcao ao icone */
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border: 7px solid transparent;
    border-right-color: #002e3b;
  }

  /* seta (preenchimento) sobreposta a borda */
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: calc(100% - 2px);
    transform: translateY(-50%);
    border: 6px solid transparent;
    border-right-color: #ffffff;
  }

  /* Telas estreitas: abre acima e a seta aponta para baixo. */
  @media (max-width: 768px) {
    left: auto;
    right: 0;
    top: auto;
    bottom: calc(100% + 10px);
    transform: none;

    &::before {
      top: 100%;
      right: 16px;
      transform: none;
      border: 7px solid transparent;
      border-top-color: #002e3b;
    }

    &::after {
      top: calc(100% - 2px);
      right: 17px;
      transform: none;
      border: 6px solid transparent;
      border-top-color: #ffffff;
    }
  }
`;

const Titulo = styled.strong`
  color: #ff9f1f;
  font-weight: 700;
`;

const InfoTooltip = ({
  children,
  label,
  ariaLabel = "Mais informações",
  className,
}) => {
  const [aberto, setAberto] = useState(false);

  const abrir = () => setAberto(true);
  const fechar = () => setAberto(false);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAberto((v) => !v);
  };

  return (
    <Container className={className}>
      <TriggerButton
        type="button"
        aria-label={ariaLabel}
        aria-expanded={aberto}
        onMouseEnter={abrir}
        onMouseLeave={fechar}
        onBlur={fechar}
        onClick={handleClick}
      >
        <FiInfo size={16} />
      </TriggerButton>
      {aberto && (
        <Box role="tooltip">
          {label && <Titulo>{label}: </Titulo>}
          {children}
        </Box>
      )}
    </Container>
  );
};

export default InfoTooltip;
